export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function readStoredJson(storage: Storage, key: string): unknown {
  try {
    const serialized = storage.getItem(key);
    return serialized === null ? undefined : JSON.parse(serialized) as unknown;
  } catch {
    return undefined;
  }
}

export function readBooleanMap(storage: Storage, key: string): Record<string, boolean> {
  const value = readStoredJson(storage, key);
  if (!isRecord(value)) return {};
  return Object.fromEntries(Object.entries(value).filter((entry): entry is [string, boolean] => typeof entry[1] === 'boolean'));
}

export function readPosition(storage: Storage, key: string): { x: number; y: number } | null {
  const value = readStoredJson(storage, key);
  if (!isRecord(value) || typeof value.x !== 'number' || !Number.isFinite(value.x)
    || typeof value.y !== 'number' || !Number.isFinite(value.y)) return null;
  return { x: value.x, y: value.y };
}

export function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item): item is string => typeof item === 'string');
}
